import { findIdentifier } from '@lifeomic/fhir-constants';

/** On a GIS requisition Task, this system identifies only MyOme's RQ id. */
const MYOME_RQ_ID_SYSTEM = 'http://lifeomic.com/fhir/myome-requisition-id';

/**
 * The MyOme RQ id on a GIS requisition Task, or `undefined` before MyOme
 * accepts the order. Treat the value as opaque.
 */
export const getMyOmeRqId = (task: fhir3.Task): string | undefined =>
  findIdentifier(task.identifier, {
    system: MYOME_RQ_ID_SYSTEM,
  })?.value?.trim() || undefined;
